import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import useFetchDetailsData from '../../../hooks/useFetchDetailsData';
import LoadingSpinner from '../../../Components/LoadingSpinner';
import AssignedTicketDetailsComponent from '../../Technician/TechnicianComponent/AssignedTicketDetailsComponent';
import { authAxiosWithBearer, baseURL } from '../../../baseURL';
import ATDetailsComponentForCompletedDeliveryResource from '../../InHouse/AssignedTechnicianForCompletedDeliveryResource/ATForCompletedDeliveryResourceComponents/ATDetailsComponentForCompletedDeliveryResource';
import AssignedSatatusChangeComponent from '../TechnicianComponent/AssignedSatatusChangeComponent';

const TechnicianWiseATDetailsForCompletedDeliveryResource = () => {
  const {id} = useParams()
  const [ticketDataLoading,setTicketDataLoading] = useState(false)
  const [ticketData,setTicketData] = useState(null)

  const { detailsData, loading, error,fetchDetailsData } = useFetchDetailsData(`in_house/api/technician-wise-assigned-technician-for-completed-delivery-resource`, {id});
  

    // fetchAssignedTicketData
    const fetchTicketData = async () => {
      setTicketDataLoading(true)
      try {
          const response = await authAxiosWithBearer.get(`${baseURL}/ccd/api/single-assign-view/${detailsData?.ticket_id}/`);
          // console.log('ticket',response.data);
          setTicketData(response.data);
      } catch (error) {
          console.log(error);
      }finally{
        setTicketDataLoading(false)
      }
      };

  useEffect(() => {
      fetchTicketData();
  }, [detailsData]);


  if(loading || ticketDataLoading){
    return <div><LoadingSpinner /> </div>
  }


  return (
    <div>

        <div className="user-details-page-title mb-5 shadow flex justify-between">
            <div className="my-auto py-2">
                <h1 className='uppercase'>Details</h1>
            </div>
        </div>

        <AssignedSatatusChangeComponent 
          title={'Assigned Status'}
          id={id} 
          fetchDetailsData={fetchDetailsData} 
          data={detailsData}
          statusUpdateURL={'in_house/api/completed-delivery-resource/technician-wise/assigned-technician-status-change'}
          redirectURL={'technician-wise-assigned-technician-for-completed-delivery-resource'}
        />

        <ATDetailsComponentForCompletedDeliveryResource data={detailsData}/>

        {/* assigned ticket details start  */}
          <AssignedTicketDetailsComponent  ticketData={ticketData} />
        {/* assigned ticket details end  */}


    </div>
  )
}

export default TechnicianWiseATDetailsForCompletedDeliveryResource